import { render, staticRenderFns } from "./AskMairaAccess.vue?vue&type=template&id=d8900ef8&scoped=true"
import script from "./AskMairaAccess.vue?vue&type=script&lang=js"
export * from "./AskMairaAccess.vue?vue&type=script&lang=js"
import style0 from "./AskMairaAccess.vue?vue&type=style&index=0&id=d8900ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8900ef8",
  null
  
)

export default component.exports